import { InjectionToken } from '@angular/core';

// Used to inject the Apollo Navigation (aka Layout) configuration into the app
export const APOLLO_LAYOUT_TOKEN = new InjectionToken('app-apollo-layout');
